import React from "react";
import { LoadingSpinner } from "../../../pages";

interface MetricCardProps {
  title: string;
  amount: number;
  percentage?: string;
  bgColor: string;
  textColor: string;
  isLoading: boolean;
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  amount,
  percentage,
  bgColor,
  textColor,
  isLoading,
}) => {
  return (
    <div className={`${bgColor} rounded-lg sm:p-5 p-3 flex-1 min-w-[300px]`}>
      <h3 className="xl:text-[15px] md:text-[14px] text-[13px] font-medium text-gray-600 mb-2">
        {title}
      </h3>
      <div className="flex items-baseline gap-2">
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <span
            className={`xl:text-[24px] md:text-[20px] text-[18px] font-semibold ${textColor}`}
          >
            {amount !== 0 ? `₦${amount.toLocaleString()}` : "--"}
          </span>
        )}
        {percentage && !isLoading && (
          <span className="font-medium xl:text-[18px] md:text-[16px] text-[15px] text-gray-700">
            {amount !== 0 && `(${percentage.toLocaleString()}%)`}
          </span>
        )}
      </div>
    </div>
  );
};

export default MetricCard;
